module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-200italic.f316c5d1ec40f3e68654c3f38b3999f3.woff2";